import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Autocomplete from "@material-ui/lab/Autocomplete"
import Input from "../../../../Input/Input"
import suggestionServices from "../../../../../services/suggestionServices"

const SUGGESTION_DELAY_MS = 250
const MAX_LENGTH = 64

/** Free text keywords with suggestions taken from existing names (opportunities unless `getSuggestions` is given). */
const KeywordsAutocomplete = ({
  value,
  onChange,
  getSuggestions,
  placeholder,
}) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    const keyword = value.trim()
    if (keyword.length < 2) {
      setOptions([])
      return undefined
    }
    let isCurrent = true
    const timer = setTimeout(() => {
      getSuggestions(keyword)
        .then(({ data }) => isCurrent && setOptions(data || []))
        .catch(() => isCurrent && setOptions([]))
    }, SUGGESTION_DELAY_MS)
    return () => {
      isCurrent = false
      clearTimeout(timer)
    }
  }, [value])

  return (
    <Autocomplete
      freeSolo
      inputValue={value}
      options={options}
      filterOptions={(items) => items}
      onInputChange={(e, inputValue) =>
        onChange(inputValue.substring(0, MAX_LENGTH))
      }
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <Input
            type="text"
            label="Keywords"
            placeholder={placeholder}
            {...params.inputProps}
          />
        </div>
      )}
    />
  )
}

KeywordsAutocomplete.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  getSuggestions: PropTypes.func,
  placeholder: PropTypes.string,
}

KeywordsAutocomplete.defaultProps = {
  getSuggestions: (keyword) =>
    suggestionServices.getOpportunityKeywords(keyword),
  placeholder: "e.g. AI, SaaS, grant",
}

export default KeywordsAutocomplete
